import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { DataService_BlockListSetup } from "../shared/data.service";
import { StationBlockAlertSelectRequest } from "../shared/station-block-alert-select-request";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { AddStationBlockAlertComponent } from "./add-station-block-alert/add-station-block-alert.component";
import { UpdateStationBlockAlertComponent } from "./update-station-block-alert/update-station-block-alert.component";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-station-block-alert-table",
	templateUrl: "./station-block-alert-table.component.html",
	styleUrls: ["./station-block-alert-table.component.css"],
})
export class StationBlockAlertTableComponent implements OnInit, OnChanges {
	constructor(private dataService: DataService_BlockListSetup, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadTable();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.onRefresh();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	@Input() SelectedSchool: any = null;
	@Input() AllDates: boolean = null;
	@Input() StartDate: Date = null;
	@Input() EndDate: Date = null;
	@Output() BlockListSelected: EventEmitter<any> = new EventEmitter();

	lstTable: any = [];
	pagerows: number = 10;
	pagefirst: number = 0;
	SelectedStationBlockAlert: any;
	//Filter lists
	lstSchoolName: any = [];
	lstPriorityDesc: any = [];
	lstActiveDesc: any = [];

	ToggleText: string = "Deactivate Block List";

	errorMessage: string = "";
	TableLoading: boolean = false;
	Processing: boolean = false;

	ShowInfo: boolean = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////

	loadTable() {
		if (
			this.SelectedSchool == undefined ||
			this.AllDates == undefined ||
			(this.AllDates == false && this.StartDate == undefined) ||
			this.EndDate == undefined
		) {
			return;
		}

		this.TableLoading = true;
		this.onRowUnselect(null);

		var parms: StationBlockAlertSelectRequest = {
			SchoolID: this.SelectedSchool.SchoolID,
			StartDate: this.AllDates == true ? "" : moment(this.StartDate).format("MM/DD/yyyy"),
			EndDate: this.AllDates == true ? "" : moment(this.EndDate).format("MM/DD/yyyy"),
		};

		var result = this.dataService.StationBlockAlertSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				//Load Data Filter Lists
				this.lstSchoolName = Array.from(new Set(this.lstTable.map((item: any) => item.SchoolName))).sort();
				this.lstPriorityDesc = Array.from(new Set(this.lstTable.map((item: any) => item.PriorityDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstTable.map((item: any) => item.ActiveDesc))).sort();

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddStationBlockAlertComponent, {
			header: "Add Block List",
			width: "fit-content",
			data: {
				SelectedSchool: this.SelectedSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}
	onUpdate() {
		this.errorMessage = "";

		if (this.SelectedStationBlockAlert == undefined) {
			this.errorMessage = "Select a Block List to Edit";
			return;
		}

		var ref = this.dialogService.open(UpdateStationBlockAlertComponent, {
			header: "Edit Block List",
			width: "fit-content",
			data: {
				SelectedSchool: this.SelectedSchool,
				SelectedStationBlockAlert: this.SelectedStationBlockAlert,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadTable();
			}
		});
	}
	onToggle() {
		this.errorMessage = "";

		if (this.SelectedStationBlockAlert == undefined) {
			this.errorMessage = "Select a Block List to Deactivate";
			return;
		}

		this.Processing = true;

		var ChangeTo = this.SelectedStationBlockAlert.Active == true ? 0 : 1;

		var result = this.dataService.StationBlockAlertToggle(this.SelectedStationBlockAlert.StationBlockAlertID, ChangeTo);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Block List was " + (ChangeTo == 1 ? "Activated" : "Deactivated") + " Successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (ChangeTo == 1 ? "Activate" : "Deactivate") + " the Block List: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}
	onDelete() {
		this.errorMessage = "";

		if (this.SelectedStationBlockAlert == undefined) {
			this.errorMessage = "Select a Block List to Delete";
			return;
		}

		this.confirmationService.confirm({
			key: "stationblockalertconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this Block List? Students assigned to it will now be able to scan in.",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Processing = true;

		var result = this.dataService.StationBlockAlertDelete(this.SelectedStationBlockAlert.StationBlockAlertID);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Block List was Deleted Successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalert",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Delete the Block List: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onShowInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////

	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedStationBlockAlert = val.data;
		this.BlockListSelected.emit(this.SelectedStationBlockAlert);

		this.ToggleText = "Deactivate Block List";
		if (this.SelectedStationBlockAlert.Active == false) {
			this.ToggleText = "Activate Block List";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedStationBlockAlert = null;
		this.BlockListSelected.emit(this.SelectedStationBlockAlert);

		this.ToggleText = "Deactivate Block List";
	}
	onDoubleClick(val) {
		this.errorMessage = "";

		this.SelectedStationBlockAlert = val;
		this.BlockListSelected.emit(this.SelectedStationBlockAlert);

		this.onUpdate();
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	AllSchools() {
		if (this.SelectedSchool == undefined) {
			return false;
		} else {
			return this.SelectedSchool.SchoolID <= 0;
		}
	}

	///////////////////////////////////////////////////////
}
